import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import BarGraph from '../DashboardTeamConnectionPoints/BarGraph';

import { movementGraphic } from '../../../assets/icons';
import {
  DashboardPanelWrapper,
  HeaderContainer,
  HeaderImage,
  TitleWrapper,
  Header,
  SubHeader,
  SubText
} from '../DashboardTeamConnectionPoints/Styles';

import { ApplicationState } from '../../../lib/Store';

const DashboardTeamMovementPoints: FC = () => {
  const { teamMembersPoints } = useSelector(
    (state: ApplicationState) => state.participantDashboardState
  );

  return (
    <DashboardPanelWrapper>
      <HeaderContainer>
        <TitleWrapper>
          <Header>Movement Points</Header>
          <SubHeader>Your Team</SubHeader>
          <SubText>Make sure to encourage them to get moving!</SubText>
        </TitleWrapper>
        <HeaderImage src={movementGraphic} />
      </HeaderContainer>
      <BarGraph data={teamMembersPoints} pointType="MOVEMENT" />
    </DashboardPanelWrapper>
  );
};

export default DashboardTeamMovementPoints;
